import React, { lazy, Suspense } from 'react';
import Hero from '../components/hero';
import Aboutthebook from '../components/About-the-book';
import PageMeta from '../components/PageMeta';

const AboutTheFilm = lazy(() => import('../components/About-the-film'));
const Crew = lazy(() => import('../components/Crew'));
const Testimonials = lazy(() => import('../components/Testimonial'));

const Home = () => {
  return (
    <>
      <PageMeta
        title="Ghosted MD | Supernatural Medical Thriller by Nafsika"
        description="Discover Ghosted MD, a supernatural medical thriller created by Nafsika Antypas, blending mystery, suspense, emotion, and the unexplained."
      />
      <Hero />
      <Aboutthebook />
      <Suspense fallback={null}>
        <AboutTheFilm />
        <Crew />
        <Testimonials />
      </Suspense>
    </>
  );
};

export default Home;
